import { Context } from './context'

// TODO: These should be API calls

const publicGroup = 4
const privateGroup = 5
const hiddenGroup = 6

export async function getGroups (ctx: Context) {
  const { prismaClient, userPermissions } = ctx
  const groups = await prismaClient.forum.findMany({
    where: {
      type: { in: [publicGroup, privateGroup, hiddenGroup] }
    },
    orderBy: {
      displayorder: 'asc'
    },
    include: {
      group_members: {
        orderBy: {
          created: 'desc'
        },
        take: 5
      },
      group_tags_groups: {
        include: {
          group_tags: true
        }
      }
    }
  })

  const readableGroups = groups.filter(g => {
    // remove hidden groups based on permissions
    return g.type !== hiddenGroup || userPermissions.readableCategories.includes(g.forumid)
  })

  const query = {
    where: {
      context: 'subforum',
      content_id: { in: groups.map(g => g.forumid) }
    }
  }

  const attachments = await prismaClient.attachment.findMany(query)

  return readableGroups.map(group => {
    const source = attachments.find(a => a.content_id === group.forumid && a.label === 'Thumbnail image')?.source_thumb || ''
    return Object.assign(group, {
      thumbnail: `${ctx.config.config.params.uploadCdn || ''}${source}`
    })
  })
}
